import { useSelector, useDispatch } from "react-redux";
import {LandingView} from "/src/views/LandingView.jsx"



export function Landing(){
    

    return <LandingView/>

};